import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
import app from 'flarum/forum/app';
import PollListItem from '../Poll/PollListItem';
import Dropdown from 'flarum/common/components/Dropdown';
import PollGroupControls from '../../utils/PollGroupControls';
import ItemList from 'flarum/common/utils/ItemList';
import PollShowcaseItem from '../Poll/PollShowcaseItem';
// import PollGroupListState from 'src/forum/states/PollGroupListState';

export default class PollGroupListItem extends Component {
  pollItems() {
    const polls = this.attrs.pollGroup.polls();
    const items = new ItemList();
    if (!polls || polls.length === 0) {
      return items;
    }
    polls.forEach(poll => {
      if (poll) {
        items.add('poll-' + poll.id(), m("li", {
          key: poll.id(),
          className: "PollGroup-poll"
        }, !this.attrs.compactView ? m(PollShowcaseItem, {
          poll: poll
        }) : m(PollListItem, {
          poll: poll
        })));
      }
    });
    return items;
  }
  mainItems() {
    const items = new ItemList();
    const pollGroup = this.attrs.pollGroup;
    items.add('title', m("h3", {
      className: "PollGroupListItem-title"
    }, pollGroup.name()));
    items.add('controls', this.controlsView(PollGroupControls.controls(pollGroup, this).toArray()));
    return items;
  }
  view() {
    const polls = this.pollItems().toArray();
    return m("div", {
      className: classList('PollGroupListItem', 'PollGroupListItem--pollgroup')
    }, m("div", {
      className: "PollGroupListItem-main"
    }, this.mainItems().toArray()), m("ul", {
      className: "PollGroupListItem-polls"
    }, polls.length > 0 ? polls : m("span", null, app.translator.trans('fof-polls.forum.poll_groups.list_page.no_polls'))));
  }
  controlsView(controls) {
    return !!controls.length && m(Dropdown, {
      icon: "fas fa-ellipsis-v",
      className: "PollGroupListItem-controls",
      menuClassName: "Dropdown-menu--right",
      buttonClassName: "Button Button--icon Button--flat",
      accessibleToggleLabel: app.translator.trans('fof-polls.forum.poll_controls.toggle_dropdown_accessible_label')
    }, controls);
  }
}
flarum.reg.add('fof-polls', 'forum/components/PollGroup/PollGroupListItem', PollGroupListItem);